/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext, useState } from 'react';
import { ApiContext } from '../../../../context/ApiContext';
import { IEmaasEnergyUsageComponentDataArea } from '../../IEnergyManagementProps';
import {
  convertUnitForPerformanceGraph,
  getPerformanceGraphData,
  getSpanDetails
} from '../../../shared/Utils/Utils';
import { ConversionType } from '../../../shared/Utils/unitHandling/UnitModel';
import CommonEnergyGraphComponent from '../../../shared/EnergyGraphKPI/CommonEnergyGraphComponent';
interface IEmaasEnergyUsageGraphComponentProps {
  data: IEmaasEnergyUsageComponentDataArea;
}

export const EmaasEnergyUsageGraphComponent = (
  props: IEmaasEnergyUsageGraphComponentProps
) => {
  const { data } = props;
  const apiContext = useContext(ApiContext);
  const { onEnergyUsageViewDetailsClick, userPreferedUnit } = apiContext;
  const onViewDetailsClick = () => {
    if (onEnergyUsageViewDetailsClick) {
      onEnergyUsageViewDetailsClick();
    }
  };

  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit = userPreferedUnit as any;
  const {
    performanceAggregation,
    aggregationsStartDate,
    aggregationsEndDate,
    performanceAggregationApplied,
    energyMeasurementUnit
  } = data;

  const SpanDetails = getSpanDetails(
    aggregationsStartDate,
    aggregationsEndDate
  );

  const convertedPerformanceData = convertUnitForPerformanceGraph(
    performanceAggregation,
    fromUnit,
    energyMeasurementUnit
  );

  const { displayUnit: performanceDisplayUnit } = convertedPerformanceData;

  const comparisonData = getPerformanceGraphData(
    performanceAggregation,
    energyMeasurementUnit,
    performanceDisplayUnit,
    performanceAggregationApplied,
    ConversionType.ELECTRICITY
  );

  const energyComponentProps = {
    onViewDetailsClick: onViewDetailsClick,
    graphData: {
      chartSeries: comparisonData,
      startTime: aggregationsStartDate,
      endTime: aggregationsEndDate,
      aggregationType: performanceAggregationApplied
    },
    dateData: SpanDetails
  };

  return <CommonEnergyGraphComponent {...energyComponentProps} />;
};
export default memo(EmaasEnergyUsageGraphComponent);
